import React, { useCallback, useMemo } from "react";
import { DEFAULT_SHOP_IMG } from "../../../conf";
import useTrack, { eventTypes } from "../../../hooks/useTrack";
import {
	ProductViewBadgeContainer,
	ProductViewExpandableCard,
	ProductViewRoundedCard,
} from "../ProductViewCore";

import "./product-view-brand-card.css";

const ProductViewBrandCard = React.memo(
	({
		brand,
		customDescription = "",
		productViewEventProps,
		inSurface = false,
	}) => {
		if (!brand) {
			return;
		}

		const track = useTrack();
		const brandDescription = useMemo(() => {
			return (
				customDescription ||
				brand.description ||
				brand.single_liner ||
				false
			);
		}, [customDescription, brand]);

		const onExpand = useCallback(() => {
			if (inSurface) {
				return;
			}
			track(eventTypes.WIDGET_PDP_BRAND_DETAIL_CLICK, {
				brand: productViewEventProps?.brand,
				brand_id: productViewEventProps?.brand_id,
				short_brand_description: brandDescription.length < 50,
			});
		}, [track, brandDescription, productViewEventProps, inSurface]);

		return (
			<ProductViewRoundedCard className="product-view-brand-card">
				<img
					className="product-view-brand-card-brand-img"
					alt=""
					src={brand.logo_url || DEFAULT_SHOP_IMG}
				/>
				<h2>About {brand.name}</h2>
				<ProductViewBadgeContainer badgeData={brand.categories} />
				{brandDescription && (
					<ProductViewExpandableCard
						expandOpenFooter="Read about the brand"
						triggerExpand={brandDescription.length < 80}
						onExpand={onExpand}
					>
						{brandDescription}
					</ProductViewExpandableCard>
				)}
			</ProductViewRoundedCard>
		);
	}
);

export default ProductViewBrandCard;
